module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_1_D.2690fd42.mp3";